const A = "/brand";
const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[8px] px-6 py-3 text-sm font-medium hover:bg-[#e8463c] transition-colors";

export function SpeakingHero() {
  return (
    <section
      data-testid="speaking-hero"
      className="relative w-full overflow-hidden"
      style={{ minHeight: "min(82vh, 720px)" }}
    >
      <img
        src={`${A}/blueprint4joy-speaking-hero-windows.jpg`}
        alt="Lara speaking in a teal blazer in a conference room with floor-to-ceiling windows."
        data-testid="speaking-hero-image"
        className="absolute inset-0 w-full h-full object-cover object-[90%_20%] md:object-[94%_20%]"
        style={{ transform: "scale(1.04)", transformOrigin: "94% 20%" }}
      />
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(to right, rgba(28,25,23,0.92) 0%, rgba(28,25,23,0.84) 28%, rgba(28,25,23,0.50) 48%, rgba(28,25,23,0.14) 62%, rgba(28,25,23,0) 72%)",
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 md:hidden"
        style={{
          background:
            "linear-gradient(to right, rgba(28,25,23,0.90) 0%, rgba(28,25,23,0.68) 52%, rgba(28,25,23,0.20) 82%, rgba(28,25,23,0) 100%)",
        }}
      />
      <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-20 md:pt-24 pb-16 min-h-[inherit] flex items-start">
        <div className="w-full max-w-[480px] reveal text-white">
          <p className="text-[11px] tracking-[0.28em] uppercase text-[#F6A041] mb-6 font-medium">
            Speaking
          </p>
          <h1
            data-testid="speaking-headline"
            className="font-display text-[44px] sm:text-[64px] lg:text-[78px] leading-[1.02] tracking-tight text-white"
          >
            Designing Lives That Actually Fit
          </h1>
          <p className="mt-7 text-xl leading-relaxed text-white/90 max-w-sm">
            Because thriving is different than surviving.
          </p>
          <p className="mt-4 text-base md:text-lg leading-relaxed text-white/80 max-w-sm">
            I help leaders, teams, and communities rethink productivity, capacity, and joy so they stop fighting themselves and start building lives that actually work.
          </p>
          <div className="mt-10">
            <a
              href="mailto:lara@blueprint4joy.com"
              data-testid="hero-book-cta"
              className={btnPrimary}
            >
              Book Lara to Speak
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
